import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CellProps } from "react-table";
import ListTextCell from "src/apps/super-admin/tabs/roles/list/PermissionCell";
import Status from "src/components/status/Status";
import TextCell from "src/components/tables/cells/TextCell";
import { getActiveApp } from "src/redux/selectors/app";
import { ACTIVE_APP, PR_PO_STATUS_CELL, PR_STATUS } from "src/utils/constants";
import { ProcurementType } from "./procurement-types";

const useProcurementTableColumns = () => {
  return [
    {
      Header: "Request ID",
      accessor: "id",
      className: "min-w-[180px]",
      Cell: ({ value, row }: CellProps<ProcurementType>) => {
        const activeApp = useSelector(getActiveApp);
        const href =
          activeApp === ACTIVE_APP.STORE
            ? "/store/vendor/procurements/create"
            : "/vendor/purchase-orders/vendor/create";
        return (
          <Link to={`${href}/${row.original.id}`}>
            <TextCell value={`#${value}`} className="text-primary" />
          </Link>
        );
      },
    },
    {
      Header: "Vendor Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: ({ row }: CellProps<ProcurementType>) => (
        <TextCell value={row.original.vendor.name} />
      ),
    },
    {
      Header: "Products",
      accessor: "products",
      className: "min-w-[150px]",
      Cell: ListTextCell,
    },
    {
      Header: "Quantity",
      accessor: "productsQuantity",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ value }: { value: PR_STATUS }) => {
        const status = PR_PO_STATUS_CELL[value];
        return <Status {...status} />;
      },
    },
  ];
};

export default useProcurementTableColumns;
